import { Toast } from 'vant';

class HttpCount {
    httpCountObj = null;
    toastObj = null;
    count = 0;
    loadingFlag = true;
    constructor() {}
    static getHttpCount() {
        if(!this.httpCountObj) {
            Toast.allowMultiple();
            this.httpCountObj = new HttpCount();
        }
        return this.httpCountObj;
    }
    add() {
        ++this.count
    }
    reduce() {
        --this.count
        if(this.count < 0) {
            this.count = 0
        }
    }
    clear() {
        this.count = 0;
        this.toastObj.clear();
    }
    changeFlag(){
        this.loadingFlag = !this.loadingFlag;
    }
    checkCountIsZero() {
        var tempCount = setTimeout(() => {
            if(this.count === 0 && this.loadingFlag === false){
                clearTimeout(tempCount);
                this.changeFlag();
                this.toastObj.clear();
            }
        }, 100);
    }
    showLoading() {
        if(this.loadingFlag){
            this.toastObj = Toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true,
                overlay: true,
            });
            this.changeFlag();
        }
    }
}

export const httpCountObj = HttpCount.getHttpCount();
